// @flow
import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

/* ---------- Banner de cabecera (desktop ≥ miniDesktop) ---------- */

export const Banner = styled.div`
  position: relative;
  overflow: hidden;
  display: none;
  align-items: center;
  gap: 16px;
  margin: 16px 0 0;
  padding: 14px 20px;
  background-color: ${({ theme }) => theme.colors.primary};
  border-radius: 12px;
  box-shadow: 0 8px 24px -14px ${({ theme }) => theme.colors.primaryD};

  /* Solo desktop: en ≤ miniDesktop la captación la cubre la barra inferior ProfileLeadBar */
  ${minMediaQueries.miniDesktop`
    display: flex;
  `};

  /* Halo decorativo para dar profundidad sin imágenes */
  &::after {
    content: '';
    position: absolute;
    top: -50px;
    right: 120px;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.primaryL};
    opacity: 0.3;
  }
`;

export const BannerIcon = styled.div`
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.15);
`;

export const BannerText = styled.div`
  position: relative;
  z-index: 1;
  flex: 1;
  min-width: 0;
`;

export const BannerTitle = styled.p`
  ${getFont(0, 'compact')};
  font-weight: 700;
  margin: 0;
  color: #fff;
`;

export const BannerSubtitle = styled.p`
  ${getFont(-1, 'compact')};
  margin: 2px 0 0;
  color: ${({ theme }) => theme.colors.uiL};

  ${maxMediaQueries.desktop`
    display: none;
  `};
`;

export const BannerAction = styled.div`
  position: relative;
  z-index: 1;
  flex: 0 0 auto;
`;

/* ---------- Barra inferior fija (móvil/tablet ≤ miniDesktop) ---------- */

export const Bar = styled.div`
  position: fixed;
  z-index: 1000;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 15px;
  padding-bottom: calc(12px + env(safe-area-inset-bottom));
  background-color: ${({ theme }) => theme.colors.primary};
  box-shadow: 0 -4px 16px -6px rgba(0, 0, 0, 0.35);

  /* Solo móvil/tablet: el sidebar (y su tarjeta) reaparece en miniDesktop */
  ${minMediaQueries.miniDesktop`
    display: none;
  `};
`;

export const BarText = styled.p`
  flex: 1;
  ${getFont(-1, 'compact')};
  font-weight: 600;
  margin: 0;
  color: #fff;
`;

export const BarClose = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  padding: 4px;
  border: 0;
  background: transparent;
  color: #fff;
  cursor: pointer;
  opacity: 0.8;

  &:hover {
    opacity: 1;
  }
`;
